/**
 * @fileOverview This file contains the implementation of the AgendaToolbar component
 * @version 1.0.0
 * @since 1.0.0
 * @author Miguel Ángel Bermea Rodríguez
 */

//#region  Imports
import {
  Toolbar,
  Typography,
  ToggleButtonGroup,
  ToggleButton,
  Grid,
  Autocomplete,
  TextField,
} from '@mui/material';

import '../../scss/Components/MaintenanceAgenda/_toolbar.scss';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleInfo,
  faMagnifyingGlass,
} from '@fortawesome/sharp-regular-svg-icons';
import { useState } from 'react';
import MoreInfoDialog from './MoreInfoDialog';
//#endregion

const AgendaToolbar = ({ assets, selectedAssets, setSelectedAssets }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <Toolbar
      className="agenda-toolbar-container"
      sx={{ backgroundColor: 'transparent', height: '10%' }}
    >
      <Grid sx={{ width: '60%' }}>
        <Typography variant="h4" component="div" className="agenda-title">
          Programa de mantenimiento a tipos de equipos
        </Typography>
        <Grid sx={{ display: 'flex', gap: 1, marginTop: '0.5rem' }}>
          <ToggleButtonGroup
            exclusive
            defaultValue={'1'}
            sx={{
              gap: 2,
            }}
          >
            <ToggleButton
              className="agenda-toggle-btn"
              selected={true}
              value={'1'}
            >
              Anual
            </ToggleButton>
            <ToggleButton
              className="agenda-toggle-btn"
              value={'2'}
              sx={{ display: 'none' }}
            >
              Mensual
            </ToggleButton>
            <ToggleButton
              className="agenda-toggle-btn"
              value={'3'}
              sx={{ display: 'none' }}
            >
              Semanal
            </ToggleButton>
          </ToggleButtonGroup>
          <Grid
            sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
            aria-owns={open ? 'agenda-popover' : undefined}
            aria-haspopup="true"
            onMouseEnter={handlePopoverOpen}
            onMouseLeave={handlePopoverClose}
          >
            <FontAwesomeIcon
              icon={faCircleInfo}
              className="agenda-more-info-icon"
            />
            <Typography className="agenda-more-info-label">
              Más información
            </Typography>
          </Grid>
          <MoreInfoDialog
            open={open}
            anchor={anchorEl}
            close={handlePopoverClose}
          />
        </Grid>
      </Grid>
      <Grid
        sx={{
          width: '40%',
          display: 'flex',
          justifyContent: 'right',
        }}
      >
        <Autocomplete
          id="agenda-assets-search"
          className="agenda-search"
          disablePortal
          multiple
          limitTags={1}
          autoComplete={true}
          options={assets}
          value={selectedAssets}
          onChange={(event, newValue) => {
            setSelectedAssets(newValue);
          }}
          getOptionLabel={(asset) => (asset ? asset.name : '')}
          isOptionEqualToValue={(option, value) => option.id === value.id} // Asegura que las opciones sean comparadas correctamente
          ListboxProps={{
            style: { maxHeight: '15rem' },
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <>
                    <FontAwesomeIcon
                      icon={faMagnifyingGlass}
                      className="agenda-search-icon"
                    />
                    {params.InputProps.startAdornment}
                  </>
                ),
              }}
              placeholder="Buscar tipo de equipo"
            />
          )}
        />
      </Grid>
    </Toolbar>
  );
};

export default AgendaToolbar;
